<template>
  <div class="nrbAboutTraining">
    <section class="section">
      <div class="container">
        <h2 class="header-font">FAQ</h2>
        <div class="about_content about_training">
          <Accordion :items="info" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import VueFaqAccordion from 'vue-faq-accordion'
//import UInput2 from "@/components/core/UInput2";
import Accordion from '@becorps/vue-accordion'
import '../../assets/Faqcustom/custom.css' // export default {
export default {
  name: 'DataScienceFaq',
  props: {
    info: {
      type: Object,
      require: true,
    },
  },
  components: {
    // //UInput2,
    // VueFaqAccordion,
    Accordion,
  },
}
</script>
